const partnerPortalUrls = {
    DEV: "https://www1-qa.moneris.com/en/login?type=partner",
    QA: "https://www1-qa.moneris.com/en/login?type=partner",
    PROD: "https://partners.moneris.com/en/login?",
  };

  export default partnerPortalUrls;